import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tabs as BaseTabs } from 'ui-base';
import styles from './Tabs.module.scss';

class Tabs extends Component {
  valueToIndex = new Map();

  render = () => {
    const { value, children, onChange, className, ...rest } = this.props;
    const content = React.Children.map(children, (child, index) => {
      if (!React.isValidElement(child)) {
        return null;
      }

      const childValue = child.props.value === undefined ? index : child.props.value;
      this.valueToIndex.set(childValue, index);
      const active = childValue === value;
      return React.cloneElement(child, {
        className: classnames(child.props.className, { [styles.active]: active }),
        active,
        onChange,
        value: childValue,
      });
    });

    return (
      <BaseTabs className={classnames(styles.root, className)} type="toggle" fullwidth {...rest}>{content}</BaseTabs>
    );
  };
}

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};

Tabs.defaultProps = {
  className: null,
  onChange: null,
  value: null
};

export { Tabs };
